import { render, staticRenderFns } from "./BillingHistory.vue?vue&type=template&id=20fdb36b&scoped=true"
import script from "./BillingHistory.vue?vue&type=script&lang=js"
export * from "./BillingHistory.vue?vue&type=script&lang=js"
import style0 from "./BillingHistory.vue?vue&type=style&index=0&id=20fdb36b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fdb36b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fdb36b')) {
      api.createRecord('20fdb36b', component.options)
    } else {
      api.reload('20fdb36b', component.options)
    }
    module.hot.accept("./BillingHistory.vue?vue&type=template&id=20fdb36b&scoped=true", function () {
      api.rerender('20fdb36b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/BillingHistory.vue"
export default component.exports